<div class="c-premiumPass">
  <div
    class="e-background"
    theming
    themingGroup="premiumpass"
    themingAsset="background"
    [themingOverride]="event?.assets">
    <slotcom-navigation-button
      type="close"
      topPosition="0"
      rightPosition="0"
      (click)="closeModal()">
    </slotcom-navigation-button>

    <slotcom-navigation-button
      type="info"
      topPosition="0"
      leftPosition="0"
      (click)="openInfo()">
    </slotcom-navigation-button>

    <div class="e-timer">
      <span class="text">{{ 'home.live-ops.global.time-left' | translate }}</span>
      <slotcom-animated-timer
        [showInDays]="true"
        [endDate]="event.endDate"
        (expired)="closeModal()"></slotcom-animated-timer>
    </div>

    <slotcom-button
      class="c-button--pink"
      (safeClick)="openOffer()">
      {{ buttonText | uppercase }}
    </slotcom-button>
  </div>
</div>
